import React, {useEffect} from 'react';
import {Route, Switch} from 'react-router-dom';
import {useDispatch} from "react-redux";
// import {TransitionGroup, CSSTransition} from "react-transition-group";
import {getTranslationLang} from './i18n';
import AuthScreensLoginByEmail from "./modules/auth/ui/screens/login-by-email";
import AuthScreensForgot from "./modules/auth/ui/screens/forgot-password";
import AuthScreen from "./modules/auth/ui/screens/login";
import ProfileInfoScreen from "./modules/auth/ui/screens/profile-info";
import AuthScreensRegister from "./modules/auth/ui/screens/registration";
import StickersComponentsDraftContinueModal from "./modules/stickers/ui/components/draft-continue-modal";
import Sidebar from './modules/layout/ui/components/sidebar';
import ErrorScreen from './modules/layout/ui/screens/error';
import {useAppTheme} from './theme/useAppTheme';
import {useBootSplash} from './theme/useBootSplash';
import LayoutComponentsLoaderProcessing from "./modules/layout/ui/components/loader-processing";

// New sticker
import ScanSticker from "./modules/business/ui/screens/scan-sticker";
import SendLinkBySms from "./modules/business/ui/screens/send-link-by-sms";
import ScanMethod from './modules/stickers/ui/screens/scan-method';
import AppComponentsChangeBrowserModal from './modules/app/ui/components/change-browser-modal';
import {loadDictionaries} from "./modules/stickers/store/dictionaries/actions";
import UserAgent from './modules/uq-ui/helpers/express-useragent';
import {checkBrowser} from './modules/app/store/check-browser/actions';
import StickerRedirect from "./modules/stickers/ui/screens/sticker-redirect";
import LayoutComponentsOverflowLoader from "./modules/layout/ui/screens/overflow-loader";
import StickerScreensShow from "./modules/stickers/ui/screens/sticker-show";
import StickerItemScreensShow from "./modules/stickers/ui/screens/sticker-item-show";
import {useTranslation} from "react-i18next";
import StickerScreensNew from "./modules/stickers/ui/screens/new-sticker";
import ModeratorCleanSticker from "./modules/moderator/ui/screens/scan-sticker";

export default function App() {
    const dispatch = useDispatch();
    const {i18n} = useTranslation();
    useAppTheme();
    const showBootSplash = useBootSplash();
    useEffect(() => {
        const userAgent = new UserAgent().parse(navigator.userAgent);
        // dispatch(checkStickerDraft())
        dispatch(loadDictionaries())
        if (userAgent.isDesktop) {
            // @ts-ignore
            document.querySelector('#root').style.maxWidth = '56vh';
        } else {
            dispatch(checkBrowser())
        }
    }, [])

    const dir = i18n.dir();
    const lang = getTranslationLang();
    const appClassNames = `app app-${lang}`;
    return (
        <div dir={dir} data-version={process.env.VERSION} className={appClassNames}>
            <StickersComponentsDraftContinueModal/>
            <Sidebar/>
            <LayoutComponentsOverflowLoader/>
            <LayoutComponentsLoaderProcessing show={showBootSplash} opacity={1}/>
            <AppComponentsChangeBrowserModal/>
            <div className="page">
                {/*<TransitionGroup>*/}
                {/*    /!*<Route render={({location}) => (*!/*/}
                {/*    <CSSTransition*/}
                {/*        classNames="fade"*/}
                {/*        key={location.key}*/}
                {/*        timeout={300}>*/}
                <Switch>
                    <Route exact path="/login" component={AuthScreen}/>
                    <Route exact path="/profile-info" component={ProfileInfoScreen}/>
                    <Route exact path="/login/email/forgot" component={AuthScreensForgot}/>
                    <Route exact path="/login/email" component={AuthScreensLoginByEmail}/>
                    <Route exact path="/register" component={AuthScreensRegister}/>
                    <Route exact path="/" component={ScanMethod}/>
                    <Route exact path="/moderator/clean-sticker" component={ModeratorCleanSticker}/>
                    <Route exact path="/business/scan-sticker" component={ScanSticker}/>
                    <Route exact path="/business/send-link-by-sms" component={SendLinkBySms}/>
                    <Route path="/stickers/:id/new" component={StickerScreensNew}/>
                    <Route exact path="/stickers/:id" component={StickerScreensShow}/>
                    <Route exact path="/stickers/:id/:itemId" component={StickerItemScreensShow}/>
                    <Route path="/:id" component={StickerRedirect}/>
                    <Route component={ErrorScreen}/>
                </Switch>
                {/*    </CSSTransition>*/}
                {/*    /!*)}/>*!/*/}
                {/*</TransitionGroup>*/}
            </div>
        </div>)
}
